import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { listVndlyWorkOrderIssues } from 'api/admin/vndly/listVndlyWorkOrderIssues'
import { vndlyKeys } from './keys'

export function useVndlyWorkOrderIssuesQuery(
  request: Parameters<typeof listVndlyWorkOrderIssues>[0]
) {
  return useQuery({
    queryKey: vndlyKeys.workOrderIssuesList(request),
    queryFn: () => listVndlyWorkOrderIssues(request),
    placeholderData: keepPreviousData,
  })
}
